import { render, staticRenderFns } from "./ApfSelectSchoolDropdown.vue?vue&type=template&id=5a79f80e"
import script from "./ApfSelectSchoolDropdown.vue?vue&type=script&lang=js"
export * from "./ApfSelectSchoolDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports